import React from "react";
import { CheckCircle2, AlertTriangle } from "lucide-react";
import { Button } from "../../ui/button";
import { formatDistanceKm, formatDurationHm } from "../../../lib/utils";

export function DailySummaryPanel({ tempRoutes, unassignedCount = 0, onFinalize, finalizing }) {
  const ready = tempRoutes.filter((r) => r.deliveryIds.size > 0);
  const unoptimizedCount = ready.filter((r) => !r.optimized).length;
  const blocked = unassignedCount > 0;
  return (
    <div className="rounded-md border border-border bg-surface p-4" data-testid="daily-summary-panel">
      <p className="mb-2 font-heading text-sm font-semibold text-text-main">Daily Route Plan</p>
      {ready.length === 0 && <p className="text-xs text-text-muted">No routes with stops yet.</p>}
      <div className="space-y-2">
        {ready.map((r) => {
          const keptCount = r.optimized ? r.optimized.steps.filter((s) => s.type === "job").length : r.deliveryIds.size;
          const total = r.deliveryIds.size;
          return (
          <div key={r.tempId} className="flex items-center justify-between rounded-sm border border-border px-3 py-2 text-xs" data-testid={`summary-row-${r.tempId}`}>
            <span className="flex items-center gap-2 font-medium text-text-main">
              <span className="h-2.5 w-2.5 rounded-full" style={{ background: r.color }} />
              Route {r.tempId} — {r.driverName}
            </span>
            <span className="text-text-muted">
              {keptCount < total ? `${keptCount} of ${total} stops (rest left over)` : `${total} stops`}
              {r.optimized ? ` · ${formatDistanceKm(r.optimized.distance)} · ${formatDurationHm(r.optimized.duration)}` : " · not optimized"}
            </span>
          </div>
          );
        })}
      </div>

      {blocked && (
        <p className="mt-3 flex items-center gap-1.5 rounded-md border border-danger/30 bg-danger-bg p-2 text-xs font-medium text-danger" data-testid="finalize-unassigned-warning">
          <AlertTriangle size={13} strokeWidth={2} /> {unassignedCount} tiffin{unassignedCount > 1 ? "s" : ""} still unassigned — assign every tiffin to a route before finalizing.
        </p>
      )}
      {!blocked && unoptimizedCount > 0 && (
        <p className="mt-3 flex items-center gap-1.5 rounded-md border border-warning/30 bg-warning-bg p-2 text-xs font-medium text-warning" data-testid="finalize-unoptimized-warning">
          <AlertTriangle size={13} strokeWidth={2} /> {unoptimizedCount} route{unoptimizedCount > 1 ? "s" : ""} not optimized yet — optimize first for the best stop order, or continue anyway.
        </p>
      )}

      <Button
        variant="accent" className="mt-3 w-full" disabled={ready.length === 0 || finalizing || blocked}
        title={blocked ? "Assign every tiffin to a route first" : undefined}
        onClick={onFinalize} data-testid="finalize-routes-button"
      >
        <CheckCircle2 size={15} strokeWidth={1.5} /> Finalize & Save Daily Routes
      </Button>
    </div>
  );
}
